export class Coupon{

    static readonly DEFAULT_COUPON_NAME = "coupon";
    static readonly RESTAURANT_OFFER_PREFIX = "offer";
    // static readonly RESTAURANT_SPECIAL_OFFER_AFFIX = "special";
    // static readonly RESTAURANT_REWARD_POINT_OFFER_AFFIX = "rewardPoint";

    couponCode:string|null;
    couponTitle:string;
    couponDescription:string;
    expirityDateTime:number|null;
    numberOfUsesLeft:number|null;
    flatDiscount:number|undefined;
    percentDiscount:number|undefined;
    relatedProductsIds:string[];
    restaurantsWhereAccepted:string[];
    minSubtotalForCouponToBeValid:number|null;
    rewardPointsCost:number|null;
    isAvailableForAvantoEatsWebsite:boolean;

    /**
     * 
     * @param couponCode 
     * @param couponTitle Title of the coupon. Will be displayed on the receipt.
     * @param couponDescription 
     * @param expirityDateTime Date time of when this coupon will be expired. Optional?
     * @param numberOfUsesLeft How many times a customer can use this coupon. After you use this coupon that many times, the coupon will be invalid.
     * @param flatDiscount How many dollars you get on this discount. A flat discount of "10" would give you a discount of $10.00 dollars.
     * @param percentDiscount Percent of the total on which the discount will be applied. A percent discount of "10" on a $150.00 dollar 
     *                         order would give you a discount of $15.00 dollars (because $15 is 10% of $150)
     * @param freeProductIds 
     * @param restaurantsWhereAccepted Id of the restaurants where this coupon would be accepted (format is "REGION.CLIENTID", example: "oshawa.mcdonalds")
     * @param minSubtotalForCouponToBeValid This coupon will only be valid if the order total is equal or above this number. If "minSubtotalForCouponToBeValid" is "15", 
     *                                      your order total needs to be at least $15 for the coupon to be valid
     * @param rewardPointsCost How many reward points it would cost a customer to apply this offer.
     * @param isAvailableForAvantoEatsWebsite If this coupon is available for the avanto eats website or not. 
     * If false, the coupon will only be available for mobile purchases.
     */
    constructor(couponCode:string|null, couponTitle:string, couponDescription:string, expirityDateTime:number|null,
                numberOfUsesLeft:number|null, flatDiscount:number|undefined, percentDiscount:number|undefined, 
                freeProductIds:string[]|null, restaurantsWhereAccepted:string[]|null,
                minSubtotalForCouponToBeValid:number|null,rewardPointsCost:number|null, isAvailableForWebSite:boolean|null){
        this.couponCode = couponCode;
        this.couponTitle = couponTitle;
        this.couponDescription = couponDescription;
        this.expirityDateTime = expirityDateTime;
        this.numberOfUsesLeft = numberOfUsesLeft;
        this.flatDiscount = flatDiscount;
        this.percentDiscount = percentDiscount;
        this.relatedProductsIds = freeProductIds==null?[]:freeProductIds;
        this.restaurantsWhereAccepted = restaurantsWhereAccepted==null?[]:restaurantsWhereAccepted;
        this.minSubtotalForCouponToBeValid = minSubtotalForCouponToBeValid;
        this.rewardPointsCost = rewardPointsCost
        this.isAvailableForAvantoEatsWebsite = isAvailableForWebSite==null?true:isAvailableForWebSite;
    }

    toAws(){
        let awsObj:any = { }

        if(this.couponCode!=null){
            awsObj["code"]=this.couponCode;
        }
        if(this.couponTitle!=null){
            awsObj["couponTitle"]=this.couponTitle;
        }
        if(this.couponDescription!=null){
            awsObj["couponDescription"]=this.couponDescription;
        }
        if(this.expirityDateTime!=null){
            awsObj["expirityDateTime"]=this.expirityDateTime;
        }
        if(this.numberOfUsesLeft!=null){
            awsObj["numberOfUsesLeft"]=this.numberOfUsesLeft;
        }
        if(this.flatDiscount!=null){
            awsObj["flatDiscount"]=this.flatDiscount;
        }
        if(this.percentDiscount!=null){
            awsObj["percentDiscount"]=this.percentDiscount;
        }
        if(this.relatedProductsIds!=null){
            awsObj["relatedProductsIds"]=this.relatedProductsIds;
        }
        if(this.restaurantsWhereAccepted!=null){
            awsObj["restaurantsWhereAccepted"]=this.restaurantsWhereAccepted;
        }
        if(this.minSubtotalForCouponToBeValid!=null){
            awsObj["minSubtotalForCouponToBeValid"]=this.minSubtotalForCouponToBeValid;
        }
        if(this.rewardPointsCost!=null){
            awsObj["rewardPointsCost"]=this.rewardPointsCost;
        }
        if(this.isAvailableForAvantoEatsWebsite!=null){
            awsObj["isAvailableForAvantoEatsWebsite"]=this.isAvailableForAvantoEatsWebsite;
        }

        return awsObj;
    }

    static newFromAws(awsData:any){
        return new Coupon(
            awsData.code,
            awsData.couponTitle,
            awsData.couponDescription,
            awsData.expirityDateTime,
            awsData.numberOfUsesLeft,
            awsData.flatDiscount,
            awsData.percentDiscount,
            awsData.relatedProductsIds,
            awsData.restaurantsWhereAccepted,
            awsData.minSubtotalForCouponToBeValid,
            awsData.rewardPointsCost,
            awsData.isAvailableForAvantoEatsWebsite
        );
    }
}